import React, { useState } from "react";
import { Box, InputBase, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import navbarsStyle from "@/styles/jss/nextjs-material-kit-pro/pages/componentsSections/navbarsStyle.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const useStyles = makeStyles(navbarsStyle);
const sanitizeInput = value => {
  return value.replace(/<.*?>/g, "").replace(/['";]/g, "");
};
const SearchContainer = styled(Box)(({
  theme
}) => ({
  display: "flex",
  alignItems: "center",
  width: 260,
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  borderRadius: 1,
  padding: theme.spacing(0.5, 2),
  color: "grey",
  marginLeft: 2,
  position: "relative"
}));
export default function SearchInput(props) {
  const classes = useStyles(); // eslint-disable-line @typescript-eslint/no-unused-vars
  const [value, setValue] = useState("");
  const handleChange = e => {
    let input = e.target.value.slice(0, 50);
    input = sanitizeInput(input);
    setValue(input);
  };
  const handleClear = () => {
    setValue("");
  };
  return /*#__PURE__*/_jsxs(SearchContainer, {
    children: [value && /*#__PURE__*/_jsx(IconButton, {
      "aria-label": "clear",
      size: "small",
      sx: {
        position: "absolute",
        left: 8,
        zIndex: 1
      },
      onClick: handleClear,
      children: /*#__PURE__*/_jsx(CloseIcon, {})
    }), /*#__PURE__*/_jsx(InputBase, {
      ...props,
      value: value,
      onChange: handleChange,
      inputProps: {
        placeholder: "Search...",
        "aria-label": "Search",
        style: {
          color: "black"
        },
        maxLength: 50
      },
      sx: {
        flex: 1,
        paddingLeft: "32px",
        "& .MuiInputBase-input::placeholder": {
          color: "grey",
          opacity: 1
        }
      }
    }), /*#__PURE__*/_jsx(IconButton, {
      "aria-label": "search",
      sx: {
        ml: 0.5
      },
      disabled: value.length < 3,
      onClick: () => {
        // handle search action here
      },
      children: /*#__PURE__*/_jsx(SearchIcon, {})
    })]
  });
}